import { Outlet } from 'react-router-dom'

import { FetchBlockedPeriodsByIdsDocument } from 'generated/resources/graphql'

import type { Back } from 'modules/core/components/Card/types'
import Loading from 'modules/core/components/Loading'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import i18n from 'modules/core/lib/i18n'

import { useModule as useTimeoffModule } from 'modules/timeoff/hooks/useModule'
import type { RouteContextParams } from 'modules/timeoff/lib/routeContextParams'

const BlockedPeriodsRootPage = () => {
  const { navigation } = useNavigation()
  const { id } = useStrictParams<'id'>()
  const { data } = useQuery(FetchBlockedPeriodsByIdsDocument, {
    variables: {
      ids: [String(id)],
    },
  })
  const blockedPeriodsPolicy = data?.timeoff.blockedPeriodsConnection?.nodes[0] || undefined

  const back: Back = {
    href: navigation.settings.timeoffPolicies.blockedPeriods.fullPath(),
    label: i18n.t('settings.time_off.blocked_periods.title'),
  }

  const { loading: loadingTimeoff, enabled: timeoffEnabled } = useTimeoffModule()

  if (loadingTimeoff) return <Loading />

  const isNotFound = !timeoffEnabled && !blockedPeriodsPolicy
  const title = blockedPeriodsPolicy?.name

  const values: RouteContextParams = {
    isNotFound,
    back,
    title,
    loading: loadingTimeoff,
    tabs: [],
    policy: undefined,
    blockedPeriodsPolicy: blockedPeriodsPolicy,
  }

  return <Outlet context={values} />
}

export default BlockedPeriodsRootPage
